import React from 'react';
import Logger from '../../util/Logger';
import './AccountBasics.css';
import User from '../../models/User';
import { connect } from 'react-redux';
import { updateAccountName } from '../../actions/accountAdmins';
import { handleErrorWithDialog } from '../../util/Errors';
import { showDialog } from '../../actions/dialog';
import { PulseLoader } from 'react-spinners';
import Tenant from '../../models/Tenant';
import { EnterpriseSettings } from '../../analytics/EnterpriseSettings';

const ORG_NAME_MAX_LENGTH = 60;

class AccountBasics extends React.Component {

  handleOrganizationNameChange = ($event) => {
    if (this.state.editing) {
      this.setState({
        organizationName: $event.target.value || ''
      });
    }
  };

  handleSaveButtonClick = ($event) => {
    $event.preventDefault();

    if (this.isSaveDisabled()) {
      // Do nothing
      return;
    }

    const { user, updateAccountName } = this.props;
    const { organizationName } = this.state;

    if (user && updateAccountName) {
      EnterpriseSettings.updateOrgName();
      updateAccountName(Tenant.getId(User.getTenant(user)), organizationName);
    }
  };

  handleOnEditClicked = ($event) => {
    $event.preventDefault();
    this.setState({ editing: true });
  };
  isSaveDisabled = () => {
    const { editing } = this.state;
    const { basicsUpdating } = this.props;
    return basicsUpdating || !editing || this.isInputError();
  };

  constructor (props) {
    super(props);

    const { user, organizationName } = this.props;
    if (!user) {
      Logger.assert('AccountBasics component cannot be used without a User object');
    }

    this.state = {
      organizationName: organizationName,
      editing: false
    };
  }

  componentWillReceiveProps (nextProps) {
    // We track the state so that UI changes are instant, but we always map the state to props
    // so that we stay synced with the latest server stuff
    if (!nextProps.basicsUpdating) {
      this.setState({
        organizationName: nextProps.organizationName,
        editing: false
      });
    }
  }

  componentDidUpdate (prevProps) {
    const { basicsError } = this.props;
    handleErrorWithDialog(basicsError, prevProps.basicsError, 'Unable to update Organization Name');
  }

  isInputError = () => {
    const { organizationName } = this.state;
    if (!organizationName) {
      return true;
    } else {
      return organizationName.length > ORG_NAME_MAX_LENGTH;
    }
  };

  render () {
    const { organizationName, editing } = this.state;
    const { user, basicsUpdating } = this.props;
    const domains = Tenant.getDomains(User.getTenant(user));
    return (
      <div className="card">
        <div className="row no-gutters">
          <div className="col-3 d-flex h-auto fix-ie align-items-center clearfix">
            <div className="text-title my-auto text-uppercase text-truncate mr-4">
              Account Basics
            </div>

            <div className="v-divider display-if-large-enough float-right" />
          </div>

          <div className="col-5 px-lg-0 px-3">
            <div className="text-subtitle">Organization Name</div>
            <div className="row no-gutters org-name align-items-center align-middle">
              { editing
                ? (
                  <form
                    name="organizationName"
                    className="col-lg-7 no-gutters"
                    onSubmit={ this.handleSaveButtonClick }>
                    <div className="col">
                      <input
                        type="text"
                        className="col pop-input pop-form-control"
                        placeholder="Enter Organization Name"
                        value={ organizationName }
                        onChange={ this.handleOrganizationNameChange } />

                      { this.isInputError() && (
                        <div className="text-error font-size-sm">
                          Organization Name must be less than { ORG_NAME_MAX_LENGTH } characters.
                        </div>
                      ) }
                    </div>
                  </form>
                )
                : (
                  <div className="font-weight-bold font-size-md name-padding text-truncate">
                    { organizationName }
                  </div>
                )
              }
              { editing && <div className="col-lg-1" /> }
              { editing
                ? (
                  <div className="col-lg-4 align-self-start pt-1">
                    <button
                      type="button"
                      className="btn pop-btn"
                      disabled={ this.isSaveDisabled() }
                      onClick={ this.handleSaveButtonClick }>
                      { basicsUpdating
                        ? <PulseLoader color="#FFFFFF" size={ 10 } />
                        : `Save`
                      }
                    </button>
                  </div>
                )
                : <i
                  className="material-icons clickable ml-3"
                  onClick={ this.handleOnEditClicked }>edit</i>
              }
            </div>
          </div>

          <div className="col-4">
            <div className="row no-gutters">
              <div className="text-subtitle">Associated Domain Names</div>
            </div>

            <div className="row no-gutters">
              <div
                className={ `col no-gutters ${domains.length > 3 &&
                'vertical-scroll-always'} domain-list` }>
                { domains.map(d => (
                  <div key={ d } className="col no-gutters domain-name">{ d }</div>)
                ) }
              </div>
            </div>

            <div className="row no-gutters">
              <div className="text-subtitle">Contact support@popinnow.com to add more domains</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const user = state.user.user;
  return {
    user: user,
    organizationName: Tenant.getName(User.getTenant(user)),
    basicsError: state.accountBasics.error,
    basicsUpdating: state.accountBasics.loading
  };
};

export default connect(mapStateToProps, { updateAccountName, showDialog })(AccountBasics);

